import { render } from "./SubmitButton.vue?vue&type=template&id=78bec307&scoped=true&ts=true"
import script from "./SubmitButton.vue?vue&type=script&lang=ts"
export * from "./SubmitButton.vue?vue&type=script&lang=ts"

import "./SubmitButton.vue?vue&type=style&index=0&id=78bec307&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-speech/democratielab-speech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bec307"]])

export default __exports__